import React from 'react';

// İmza görseli: parlayan tel-kafes küre + üzerinde veri bağlantı yayları.
// "150+ ülkede küresel kapsama" vaadini somutlaştırır. Salt dekoratif.
const CoverageArt = () => (
  <svg
    className="coverage-art"
    viewBox="0 0 600 600"
    fill="none"
    aria-hidden="true"
    focusable="false"
  >
    <defs>
      <linearGradient id="arcGrad" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0" stopColor="#3b82f6" />
        <stop offset="1" stopColor="#22d3ee" />
      </linearGradient>
      <radialGradient id="globeGlow" cx="0.5" cy="0.5" r="0.5">
        <stop offset="0" stopColor="#1e3a5f" stopOpacity="0.55" />
        <stop offset="1" stopColor="#0a0f1c" stopOpacity="0" />
      </radialGradient>
      <clipPath id="globeClip">
        <circle cx="420" cy="430" r="220" />
      </clipPath>
    </defs>

    {/* küre parıltısı */}
    <circle cx="420" cy="430" r="240" fill="url(#globeGlow)" />

    {/* tel-kafes küre */}
    <g clipPath="url(#globeClip)" stroke="rgba(148,163,184,0.20)" strokeWidth="1">
      <circle cx="420" cy="430" r="220" stroke="rgba(148,163,184,0.34)" />
      {/* paraleller */}
      <ellipse cx="420" cy="430" rx="220" ry="62" />
      <ellipse cx="420" cy="348" rx="200" ry="54" />
      <ellipse cx="420" cy="512" rx="200" ry="54" />
      <ellipse cx="420" cy="276" rx="150" ry="42" />
      <ellipse cx="420" cy="584" rx="150" ry="42" />
      {/* meridyenler */}
      <ellipse cx="420" cy="430" rx="62" ry="220" />
      <ellipse cx="420" cy="430" rx="140" ry="220" />
      <ellipse cx="420" cy="430" rx="200" ry="220" />
    </g>

    {/* veri bağlantı yayları */}
    <path
      className="coverage-arc"
      d="M180 360 Q 360 170 560 300"
      stroke="url(#arcGrad)"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      className="coverage-arc"
      d="M150 470 Q 330 300 520 470"
      stroke="url(#arcGrad)"
      strokeWidth="1.6"
      strokeLinecap="round"
      opacity="0.7"
    />

    {/* düğümler */}
    <circle className="coverage-node" cx="180" cy="360" r="5" fill="#22d3ee" />
    <circle className="coverage-node coverage-node-2" cx="560" cy="300" r="5" fill="#3b82f6" />
    <circle className="coverage-node coverage-node-3" cx="520" cy="470" r="4" fill="#22d3ee" />
  </svg>
);

export default CoverageArt;
